import { render } from "./team-members-list.vue?vue&type=template&id=9023cc3e&scoped=true&ts=true"
import script from "./team-members-list.vue?vue&type=script&lang=ts"
export * from "./team-members-list.vue?vue&type=script&lang=ts"

import "./team-members-list.vue?vue&type=style&index=0&id=9023cc3e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9023cc3e"]])

export default __exports__